import script from "./WebhookModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./WebhookModal.vue?vue&type=script&setup=true&lang=ts"

import "./WebhookModal.vue?vue&type=style&index=0&id=76d8329f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76d8329f"]])

export default __exports__